export const environment = {
    envName:'development',
    production:false,
    version:'1.0.0',
    apiUrl: 'https://staging.plugindfi.com',
    apiLogUrl: 'https://staging.plugindfi.com/auth'
}